// AUTO-GENERATED plan-card translations (names, features, labels).
// Hand-written PLAN_I18N in plans.js still takes priority.
export const PLAN_I18N_GEN = {
"nl": {
"free": {
"name": "Freemium",
"f": [
"1 vestiging",
"Maximaal 20 items/maand",
"Geen statistieken",
"Geen automatische facturering",
"Wereldwijd beschikbaar"
]
},
"small": {
"name": "Starter — Hotels, sportscholen, restaurants",
"f": [
"1 vestiging inbegrepen + onbeperkte secundaire sites",
"Onbeperkte items",
"Basisstatistieken",
"Automatische facturering"
]
},
"medium": {
"name": "Business — Winkelcentra, musea, universiteiten",
"f": [
"Tot 3 vestigingen inbegrepen",
"Onbeperkte items",
"Geavanceerde statistieken",
"Ledenuitnodigingen · Geconsolideerde facturering"
]
},
"quote": {
"name": "Enterprise — Luchthavens, spoorwegnetwerken, internationale ketens",
"f": [
"Onbeperkt volume",
"Toegewijde implementatie",
"SLA & ondersteuning",
"Aangepaste facturering"
]
},
"priceFree": "Gratis",
"quoteLabel": "Aangepaste offerte",
"perMonth": "/maand",
"secTpl": "Extra vestiging: {p}/maand (-20%)"
},
"pl": {
"free": {
"name": "Freemium",
"f": [
"1 punkt",
"maksymalnie 20 przedmiotów/miesiąc",
"Brak statystyk",
"Brak automatycznego rozliczenia",
"Dostępne na całym świecie"
]
},
"small": {
"name": "Starter — Hotele, siłownie, restauracje",
"f": [
"1 punkt wliczony + nieograniczone strony dodatkowe",
"Nieograniczone przedmioty",
"Podstawowe statystyki",
"Automatyczne rozliczenie"
]
},
"medium": {
"name": "Business — Centra handlowe, muzea, uniwersytety",
"f": [
"Do 3 punktów wliczonych",
"Nieograniczone przedmioty",
"Zaawansowane statystyki",
"Zaproszenia dla członków · Skonsolidowane rozliczenie"
]
},
"quote": {
"name": "Enterprise — Lotniska, sieci kolejowe, międzynarodowe sieci",
"f": [
"Nieograniczony wolumen",
"Dedykowane wdrożenie",
"SLA i wsparcie",
"Custom billing"
]
},
"priceFree": "Darmowy",
"quoteLabel": "Indywidualna wycena",
"perMonth": "/miesiąc",
"secTpl": "Dodatkowy punkt: {p}/miesiąc (-20%)"
},
"ru": {
"free": {
"name": "Фремиум",
"f": [
"1 заведение",
"максимум 20 товаров/месяц",
"Нет статистики",
"Нет автоматической оплаты",
"Доступно по всему миру"
]
},
"small": {
"name": "Стартовый — Отели, спортзалы, рестораны",
"f": [
"1 заведение включено + неограниченное количество вторичных сайтов",
"Неограниченное количество товаров",
"Основная статистика",
"Автоматическая оплата"
]
},
"medium": {
"name": "Бизнес — ТЦ, музеи, университеты",
"f": [
"До 3 заведений включено",
"Неограниченное количество товаров",
"Расширенная статистика",
"Приглашения участников · Консолидированная оплата"
]
},
"quote": {
"name": "Корпоративный — Аэропорты, железнодорожные сети, международные сети",
"f": [
"Неограниченный объем",
"Выделенное развертывание",
"SLA и поддержка",
"Индивидуальная оплата"
]
},
"priceFree": "Бесплатно",
"quoteLabel": "Индивидуальная рассылка",
"perMonth": "/месяц",
"secTpl": "Дополнительное заведение: {p}/месяц (-20%)"
},
"uk": {
"free": {
"name": "Фріміум",
"f": [
"1 заклад",
"20 одиниць/місяць максимум",
"Без статистики",
"Без автоматичного виставлення рахунків",
"Доступно у всьому світі"
]
},
"small": {
"name": "Початковий — Готелі, спортзали, ресторани",
"f": [
"1 заклад включено + необмежена кількість вторинних сайтів",
"Необмежена кількість одиниць",
"Базова статистика",
"Автоматичне виставлення рахунків"
]
},
"medium": {
"name": "Бізнес — ТЦ, музеї, університети",
"f": [
"До 3 закладів включено",
"Необмежена кількість одиниць",
"Розширена статистика",
"Запрошення членів · Консолідоване виставлення рахунків"
]
},
"quote": {
"name": "Корпоративний — Аеропорти, залізничні мережі, міжнародні мережі",
"f": [
"Необмежений обсяг",
"Спеціалізоване впровадження",
"SLA та підтримка",
"Індивідуальне виставлення рахунків"
]
},
"priceFree": "Безкоштовно",
"quoteLabel": "Індивідуальна пропозиція",
"perMonth": "/міс",
"secTpl": "Додатковий заклад: {p}/міс (-20%)"
},
"ar": {
"free": {
"name": "مجاني",
"f": [
"منشأة واحدة",
"20 عنصر/شهر كحد أقصى",
"لا إحصائيات",
"لا فواتير تلقائية",
"متاح في جميع أنحاء العالم"
]
},
"small": {
"name": "بداية — فنادق، صالات رياضية، مطاعم",
"f": [
"منشأة واحدة مشمولة + مواقع ثانوية غير محدودة",
"عناصر غير محدودة",
"إحصائيات أساسية",
"فواتير تلقائية"
]
},
"medium": {
"name": "أعمال — مولات، متاحف، جامعات",
"f": [
"حتى 3 منشآت مشمولة",
"عناصر غير محدودة",
"إحصائيات متقدمة",
"دعوات الأعضاء · فواتير موحدة"
]
},
"quote": {
"name": "مؤسسة — مطارات، شبكات السكك الحديدية، سلاسل دولية",
"f": [
"حجم غير محدود",
"نشر مخصص",
"اتفاقية مستوى الخدمة والدعم",
"فواتير مخصصة"
]
},
"priceFree": "مجاني",
"quoteLabel": "عرض مخصص",
"perMonth": "/شهر",
"secTpl": "منشأة إضافية: {p}/شهر (-20%)"
},
"he": {
"free": {
"name": "פרימיום",
"f": [
"מקום אחד",
"20 פריטים/חודש מקסימום",
"אין סטטיסטיקות",
"אין חיוב אוטומטי",
"זמין בכל מקום"
]
},
"small": {
"name": "מתחילים — מלונות, חדרי כושר, מסעדות",
"f": [
"מקום אחד כלול + אתרים משניים ללא הגבלה",
"פריטים ללא הגבלה",
"סטטיסטיקות בסיסיות",
"חיוב אוטומטי"
]
},
"medium": {
"name": "עסקי — קניונים, מוזיאונים, אוניברסיטאות",
"f": [
"עד 3 מקומות כלולים",
"פריטים ללא הגבלה",
"סטטיסטיקות מתקדמות",
"הזמנות לחברים · חיוב מאוחד"
]
},
"quote": {
"name": "ארגוני — נמלי תעופה, רשתות רכבת, רשתות בינלאומיות",
"f": [
"נפח ללא הגבלה",
"הטמעה ייעודית",
"SLA & תמיכה",
"חיוב מותאם אישית"
]
},
"priceFree": "חינם",
"quoteLabel": "ציטוט מותאם",
"perMonth": "/חודש",
"secTpl": "מקום נוסף: {p}/חודש (-20%)"
},
"zh": {
"free": {
"name": "免费版",
"f": [
"1个场所",
"每月最多20个项目",
"无统计数据",
"无自动计费",
"全球可用"
]
},
"small": {
"name": "入门版 — 酒店、健身房、餐馆",
"f": [
"包含1个场所 + 无限额外站点",
"无限项目",
"基本统计",
"自动计费"
]
},
"medium": {
"name": "商务版 — 商场、博物馆、大学",
"f": [
"最多包含3个场所",
"无限项目",
"高级统计",
"会员邀请 · 综合计费"
]
},
"quote": {
"name": "企业版 — 机场、铁路网络、国际连锁",
"f": [
"无限量",
"专用部署",
"服务级别协议和支持",
"自定义计费"
]
},
"priceFree": "免费",
"quoteLabel": "自定义报价",
"perMonth": "/月",
"secTpl": "额外场所：{p}/月 (-20%)"
},
"hi": {
"free": {
"name": "फ्रीमियम",
"f": [
"1 प्रतिष्ठान",
"20 आइटम/महीना अधिकतम",
"कोई आंकड़े नहीं",
"कोई स्वचालित बिलिंग नहीं",
"दुनिया भर में उपलब्ध"
]
},
"small": {
"name": "स्टार्टर — होटलों, जिमों, रेस्तरां",
"f": [
"1 प्रतिष्ठान शामिल + अनलिमिटेड सेकेंडरी साइट्स",
"अनलिमिटेड आइटम",
"बुनियादी आंकड़े",
"स्वचालित बिलिंग"
]
},
"medium": {
"name": "बिजनेस — मॉल, संग्रहालय, विश्वविद्यालय",
"f": [
"3 प्रतिष्ठानों तक शामिल",
"अनलिमिटेड आइटम",
"उन्नत आंकड़े",
"सदस्य आमंत्रण · समेकित बिलिंग"
]
},
"quote": {
"name": "Enterprise — एयरपोर्ट, रेल नेटवर्क, अंतरराष्ट्रीय श्रृंखलाएँ",
"f": [
"अनलिमिटेड वॉल्यूम",
"समर्पित डेयर",
"SLA और सहायता",
"कस्टम बिलिंग"
]
},
"priceFree": "मुफ्त",
"quoteLabel": "कस्टम कोट",
"perMonth": "/महीना",
"secTpl": "अतिरिक्त प्रतिष्ठान: {p}/महीना (-20%)"
},
"id": {
"free": {
"name": "Freemium",
"f": [
"1 lokasi",
"20 item/bulan maksimum",
"Tidak ada statistik",
"Tidak ada penagihan otomatis",
"Tersedia di seluruh dunia"
]
},
"small": {
"name": "Pemula — Hotel, gym, restoran",
"f": [
"1 lokasi termasuk + lokasi sekunder tak terbatas",
"Item tak terbatas",
"Statistik dasar",
"Penagihan otomatis"
]
},
"medium": {
"name": "Bisnis — Mall, museum, universitas",
"f": [
"Hingga 3 lokasi termasuk",
"Item tak terbatas",
"Statistik lanjutan",
"Undangan anggota · Penagihan terintegrasi"
]
},
"quote": {
"name": "Enterprise — Bandara, jaringan kereta, rantai internasional",
"f": [
"Volume tak terbatas",
"Penerapan khusus",
"SLA & dukungan",
"Penagihan kustom"
]
},
"priceFree": "Gratis",
"quoteLabel": "Penawaran kustom",
"perMonth": "/mo",
"secTpl": "Lokasi tambahan: {p}/mo (-20%)"
},
"th": {
"free": {
"name": "ฟรีมีอาม",
"f": [
"สถานประกอบการ 1 แห่ง",
"จำนวนสูงสุด 20 รายการ/เดือน",
"ไม่มีสถิติ",
"ไม่มีการเรียกเก็บเงินอัตโนมัติ",
"มีให้บริการทั่วโลก"
]
},
"small": {
"name": "เริ่มต้น — โรงแรม, ฟิตเนส, ร้านอาหาร",
"f": [
"สถานประกอบการ 1 แห่งรวม + เว็บไซต์รองไม่จำกัด",
"รายการไม่จำกัด",
"สถิติพื้นฐาน",
"การเรียกเก็บเงินอัตโนมัติ"
]
},
"medium": {
"name": "ธุรกิจ — ห้างสรรพสินค้า, พิพิธภัณฑ์, มหาวิทยาลัย",
"f": [
"สถานประกอบการสูงสุด 3 แห่งรวม",
"รายการไม่จำกัด",
"สถิติขั้นสูง",
"การเชิญสมาชิก · การเรียกเก็บเงินรวม"
]
},
"quote": {
"name": "องค์กร — สนามบิน, เครือข่ายรถไฟ, เครือข่ายนานาชาติ",
"f": [
"ปริมาณไม่จำกัด",
"การปรับใช้เฉพาะ",
"SLA & สนับสนุน",
"การเรียกเก็บเงินแบบกำหนดเอง"
]
},
"priceFree": "ฟรี",
"quoteLabel": "ใบเสนอราคาตามต้องการ",
"perMonth": "/เดือน",
"secTpl": "สถานประกอบการเพิ่มเติม: {p}/เดือน (-20%)"
},
"vi": {
"free": {
"name": "Freemium",
"f": [
"1 cơ sở",
"Tối đa 20 mặt hàng/tháng",
"Không có thống kê",
"Không có lập hóa đơn tự động",
"Có sẵn trên toàn thế giới"
]
},
"small": {
"name": "Khởi đầu — Khách sạn, phòng gym, nhà hàng",
"f": [
"1 cơ sở được bao gồm + số lượng không giới hạn các trang phụ",
"Mặt hàng không giới hạn",
"Thống kê cơ bản",
"Lập hóa đơn tự động"
]
},
"medium": {
"name": "Doanh nghiệp — Trung tâm thương mại, bảo tàng, trường đại học",
"f": [
"Tối đa 3 cơ sở được bao gồm",
"Mặt hàng không giới hạn",
"Thống kê nâng cao",
"Lời mời thành viên · Lập hóa đơn hợp nhất"
]
},
"quote": {
"name": "Doanh nghiệp — Sân bay, mạng lưới đường sắt, chuỗi quốc tế",
"f": [
"Khối lượng không giới hạn",
"Triển khai chuyên dụng",
"SLA & hỗ trợ",
"Lập hóa đơn tùy chỉnh"
]
},
"priceFree": "Miễn phí",
"quoteLabel": "Báo giá tùy chỉnh",
"perMonth": "/mo",
"secTpl": "Cơ sở bổ sung: {p}/mo (-20%)"
},
"el": {
"free": {
"name": "Freemium",
"f": [
"1 κατάστημα",
"20 αντικείμενα/μήνα μέγιστο",
"Χωρίς στατιστικά",
"Χωρίς αυτόματη χρέωση",
"Διαθέσιμο παγκοσμίως"
]
},
"small": {
"name": "Starter — Ξενοδοχεία, γυμναστήρια, εστιατόρια",
"f": [
"1 κατάστημα περιλαμβάνεται + απεριόριστες δευτερεύουσες τοποθεσίες",
"Απεριόριστα αντικείμενα",
"Βασικά στατιστικά",
"Αυτόματη χρέωση"
]
},
"medium": {
"name": "Business — Εμπορικά κέντρα, μουσεία, πανεπιστήμια",
"f": [
"Έως 3 καταστήματα περιλαμβάνονται",
"Απεριόριστα αντικείμενα",
"Προχωρημένα στατιστικά",
"Πρόσκληση μελών · Συγκεντρωμένη χρέωση"
]
},
"quote": {
"name": "Enterprise — Αεροδρόμια, σιδηροδρομικά δίκτυα, διεθνείς αλυσίδες",
"f": [
"Απεριόριστος όγκος",
"Αφοσιωμένη ανάπτυξη",
"SLA & υποστήριξη",
"Προσαρμοσμένη χρέωση"
]
},
"priceFree": "Δωρεάν",
"quoteLabel": "Προσαρμοσμένη προσφορά",
"perMonth": "/μηνα",
"secTpl": "Επιπλέον κατάστημα: {p}/μηνα (-20%)"
},
"sv": {
"free": {
"name": "Freemium",
"f": [
"1 verksamhet",
"20 artiklar/månad max",
"Ingen statistik",
"Ingen automatisk fakturering",
"Tillgänglig över hela världen"
]
},
"small": {
"name": "Startpaket — Hotell, träningsanläggningar, restauranger",
"f": [
"1 verksamhet ingår + obegränsade sekundära sidor",
"Obegränsade artiklar",
"Grundläggande statistik",
"Automatisk fakturering"
]
},
"medium": {
"name": "Affär — Köpcenter, museer, universitet",
"f": [
"Upp till 3 verksamheter ingår",
"Obegränsade artiklar",
"Avancerad statistik",
"Medlemsinbjudningar · Samlad fakturering"
]
},
"quote": {
"name": "Företag — Flygplatser, järnvägsnät, internationella kedjor",
"f": [
"Obegränsat volym",
"Dedikerad distribution",
"SLA & stöd",
"Anpassad fakturering"
]
},
"priceFree": "Gratis",
"quoteLabel": "Anpassad offert",
"perMonth": "/månad",
"secTpl": "Extra verksamhet: {p}/månad (-20%)"
},
"da": {
"free": {
"name": "Freemium",
"f": [
"1 etablering",
"20 varer/måned maksimum",
"Ingen statistik",
"Ingen automatisk fakturering",
"Tilgængelig verden over"
]
},
"small": {
"name": "Starter — Hoteller, fitnesscentre, restauranter",
"f": [
"1 etablering inkluderet + ubegrænsede sekundære sites",
"Ubegrænsede varer",
"Basisstatistik",
"Automatisk fakturering"
]
},
"medium": {
"name": "Business — Indkøbscentre, museer, universiteter",
"f": [
"Op til 3 etableringer inkluderet",
"Ubegrænsede varer",
"Avanceret statistik",
"Medlemsinvitationer · Konsolideret fakturering"
]
},
"quote": {
"name": "Enterprise — Lufthavne, jernbanenet, internationale kæder",
"f": [
"Ubegrænset volumen",
"Dedikeret implementering",
"SLA & support",
"Tilpasset fakturering"
]
},
"priceFree": "Gratis",
"quoteLabel": "Tilpasset tilbud",
"perMonth": "/mo",
"secTpl": "Ekstra etablering: {p}/mo (-20%)"
},
"fi": {
"free": {
"name": "Freemium",
"f": [
"1 toimipaikka",
"20 artikkelia/kuukausi enintään",
"Ei tilastoja",
"Ei automaattista laskutusta",
"Saatavilla maailmanlaajuisesti"
]
},
"small": {
"name": "Aloitus — Hotellit, kuntosalit, ravintolat",
"f": [
"1 toimipaikka sisältyy + rajattomat toissijaiset sivustot",
"Rajattomat artikkelit",
"Perustilastot",
"Automaattinen laskutus"
]
},
"medium": {
"name": "Liiketoiminta — Ostoskeskukset, museot, yliopistot",
"f": [
"Enintään 3 toimipaikkaa sisältyy",
"Rajattomat artikkelit",
"Kehittyneet tilastot",
"Jäsenkutsut · Yhdistelemät laskutus"
]
},
"quote": {
"name": "Yritys — Lentokentät, rautatieverkot, kansainväliset ketjut",
"f": [
"Rajaton määrä",
"Oma käyttöönotto",
"SLA & tuki",
"Mukautettu laskutus"
]
},
"priceFree": "Ilmainen",
"quoteLabel": "Mukautettu tarjous",
"perMonth": "/kk",
"secTpl": "Lisätoimipaikka: {p}/kk (-20%)"
},
"no": {
"free": {
"name": "Freemium",
"f": [
"1 etablering",
"20 varer/måned maksimum",
"Ingen statistikk",
"Ingen automatisk fakturering",
"Tilgjengelig over hele verden"
]
},
"small": {
"name": "Starter — Hoteller, treningssentre, restauranter",
"f": [
"1 etablert inkludert + ubegrensede sekundære steder",
"Ubegrensede varer",
"Grunnleggende statistikk",
"Automatisk fakturering"
]
},
"medium": {
"name": "Business — Kjøpesentre, museer, universiteter",
"f": [
"Opp til 3 etableringer inkludert",
"Ubegrensede varer",
"Avansert statistikk",
"Medleminvitasjoner · Samlet fakturering"
]
},
"quote": {
"name": "Enterprise — Lufthavner, jernbanenettverk, internasjonale kjeder",
"f": [
"Ubegrenset volum",
"Dedikert distribusjon",
"SLA & support",
"Tilpasset fakturering"
]
},
"priceFree": "Gratis",
"quoteLabel": "Egendefinert tilbud",
"perMonth": "/måned",
"secTpl": "Ekstra etablering: {p}/måned (-20%)"
},
"cs": {
"free": {
"name": "Freemium",
"f": [
"1 zařízení",
"Maximálně 20 položek/měsíc",
"Žádná statistika",
"Žádné automatické fakturace",
"Dostupné po celém světě"
]
},
"small": {
"name": "Starter — Hotely, fitka, restaurace",
"f": [
"1 zařízení zahrnuto + neomezené sekundární stránky",
"Neomezené položky",
"Základní statistika",
"Automatické fakturace"
]
},
"medium": {
"name": "Business — Nákupní centra, muzea, univerzity",
"f": [
"Až 3 zařízení zahrnuta",
"Neomezené položky",
"Pokročilé statistiky",
"Pozvánky pro členy · Sjednocená fakturace"
]
},
"quote": {
"name": "Enterprise — Letiště, železniční sítě, mezinárodní řetězce",
"f": [
"Neomezený objem",
"Dedikované nasazení",
"SLA & podpora",
"Vlastní fakturace"
]
},
"priceFree": "Zdarma",
"quoteLabel": "Vlastní nabídka",
"perMonth": "/měsíc",
"secTpl": "Další zařízení: {p}/měsíc (-20%)"
},
"ro": {
"free": {
"name": "Freemium",
"f": [
"1 stabiliment",
"Maximum 20 articole/lună",
"Fără statistici",
"Fără facturare automată",
"Disponibil la nivel mondial"
]
},
"small": {
"name": "Starter — Hoteluri, săli de sport, restaurante",
"f": [
"1 stabiliment inclus + site-uri secundare nelimitate",
"Articole nelimitate",
"Statistici de bază",
"Facturare automată"
]
},
"medium": {
"name": "Business — Centre comerciale, muzee, universități",
"f": [
"Până la 3 stabilimente incluse",
"Articole nelimitate",
"Statistici avansate",
"Invitații pentru membri · Facturare consolidată"
]
},
"quote": {
"name": "Enterprise — Aeroporturi, rețele feroviare, lanțuri internaționale",
"f": [
"Volum nelimitat",
"Implementare dedicată",
"SLA & suport",
"Facturare personalizată"
]
},
"priceFree": "Gratuit",
"quoteLabel": "Ofertă personalizată",
"perMonth": "/lună",
"secTpl": "Stabiliment suplimentar: {p}/lună (-20%)"
},
"hu": {
"free": {
"name": "Freemium",
"f": [
"1 létesítmény",
"20 tétel/hónap maximum",
"Nincsenek statisztikák",
"Nincs automatikus számlázás",
"Világszerte elérhető"
]
},
"small": {
"name": "Kezdő — Szállodák, edzőtermek, éttermek",
"f": [
"1 létesítmény beleértve + korlátlan másodlagos helyszínek",
"Korlátlan tételek",
"Alap statisztikák",
"Automatikus számlázás"
]
},
"medium": {
"name": "Üzleti — Bevásárlóközpontok, múzeumok, egyetemek",
"f": [
"Maximum 3 létesítmény beleértve",
"Korlátlan tételek",
"Fejlett statisztikák",
"Tagok meghívása · Összesített számlázás"
]
},
"quote": {
"name": "Vállalati — Repülőterek, vasúti hálózatok, nemzetközi láncok",
"f": [
"Korlátlan mennyiség",
"Dedikált telepítés",
"SLA & támogatás",
"Testreszabott számlázás"
]
},
"priceFree": "Ingyenes",
"quoteLabel": "Testreszabott ajánlat",
"perMonth": "/hó",
"secTpl": "Extra létesítmény: {p}/hó (-20%)"
},
"sk": {
"free": {
"name": "Freemium",
"f": [
"1 prevádzka",
"20 položiek / mesiac maximálne",
"Žiadne štatistiky",
"Žiadne automatické fakturovanie",
"Dostupné po celom svete"
]
},
"small": {
"name": "Začiatok — Hotely, telocvične, reštaurácie",
"f": [
"1 prevádzka zahrnutá + neobmedzené sekundárne stránky",
"Neobmedzené položky",
"Základné štatistiky",
"Automatické fakturovanie"
]
},
"medium": {
"name": "Podnikanie — Nákupné centrá, múzeá, univerzity",
"f": [
"Až 3 prevádzky zahrnuté",
"Neobmedzené položky",
"Pokročilé štatistiky",
"Pozvánky pre členov · Konsolidované fakturovanie"
]
},
"quote": {
"name": "Podnikový — Letiská, železničné siete, medzinárodné reťazce",
"f": [
"Neobmedzený objem",
"Vyhradené nasadenie",
"SLA a podpora",
"Prispôsobené fakturovanie"
]
},
"priceFree": "Zdarma",
"quoteLabel": "Prispôsobená ponuka",
"perMonth": "/mes",
"secTpl": "Extra prevádzka: {p}/mes (-20%)"
},
"bg": {
"free": {
"name": "Фремиум",
"f": [
"1 заведение",
"Максимум 20 артикула/месец",
"Без статистики",
"Без автоматично фактуриране",
"Наличен в световен мащаб"
]
},
"small": {
"name": "Стартер — Хотели, фитнеси, ресторанти",
"f": [
"1 заведение включено + неограничени вторични обекти",
"Неограничен брой артикули",
"Основна статистика",
"Автоматично фактуриране"
]
},
"medium": {
"name": "Бизнес — Молове, музеи, университети",
"f": [
"До 3 заведений включени",
"Неограничен брой артикули",
"Разширена статистика",
"Покани за членство · Консолидирано фактуриране"
]
},
"quote": {
"name": "Предприятие — Летища, железопътни мрежи, международни вериги",
"f": [
"Неограничен обем",
"Специализирано внедряване",
"SLA и поддръжка",
"Персонализирано фактуриране"
]
},
"priceFree": "Безплатно",
"quoteLabel": "Персонализирана оферта",
"perMonth": "/месец",
"secTpl": "Допълнително заведение: {p}/месец (-20%)"
},
"hr": {
"free": {
"name": "Freemium",
"f": [
"1 objekt",
"maksimalno 20 stavki/mjesec",
"Bez statistike",
"Bez automatskog naplaćivanja",
"Dostupno širom svijeta"
]
},
"small": {
"name": "Starter — Hoteli, teretane, restorani",
"f": [
"1 uključeni objekt + neograničeni sekundarni siteovi",
"Neograničene stavke",
"Osnovna statistika",
"Automatsko naplaćivanje"
]
},
"medium": {
"name": "Business — Trgovački centri, muzeji, sveučilišta",
"f": [
"Do 3 uključena objekta",
"Neograničene stavke",
"Napredna statistika",
"Pozivnice za članove · Konsolidirano naplaćivanje"
]
},
"quote": {
"name": "Enterprise — Zračne luke, željezničke mreže, međunarodni lanci",
"f": [
"Neograničen volumen",
"Posvećeno implementacija",
"SLA i podrška",
"Prilagođeno naplaćivanje"
]
},
"priceFree": "Besplatno",
"quoteLabel": "Prilagođena ponuda",
"perMonth": "/mo",
"secTpl": "Dodatni objekt: {p}/mo (-20%)"
},
"ca": {
"free": {
"name": "Freemium",
"f": [
"1 establiment",
"20 articles/mensual màxim",
"Sense estadístiques",
"Sense facturació automàtica",
"Disponible a tot el món"
]
},
"small": {
"name": "Starter — Hotels, gimnasos, restaurants",
"f": [
"1 establiment inclòs + llocs secundaris il·limitats",
"Articles il·limitats",
"Estadístiques bàsiques",
"Facturació automàtica"
]
},
"medium": {
"name": "Business — Centres comercials, museus, universitats",
"f": [
"Fins a 3 establiments inclosos",
"Articles il·limitats",
"Estadístiques avançades",
"Invitacions de membres · Facturació consolidada"
]
},
"quote": {
"name": "Enterprise — Aeroports, xarxes ferroviàries, cadenes internacionals",
"f": [
"Volum il·limitat",
"Desplegament dedicat",
"SLA i suport",
"Facturació personalitzada"
]
},
"priceFree": "Gratuït",
"quoteLabel": "Pressupost personalitzat",
"perMonth": "/mes",
"secTpl": "Establiment extra: {p}/mes (-20%)"
},
"ja": {
"free": {
"name": "フリーミアム",
"f": [
"1つの施設",
"最大20アイテム/月",
"統計なし",
"自動請求なし",
"世界中で利用可能"
]
},
"small": {
"name": "スターター — ホテル、ジム、レストラン",
"f": [
"1つの施設が含まれています + 無制限のサブサイト",
"無制限のアイテム",
"基本的な統計",
"自動請求"
]
},
"medium": {
"name": "ビジネス — モール、博物館、大学",
"f": [
"最大3つの施設が含まれています",
"無制限のアイテム",
"高度な統計",
"メンバー招待 · 一括請求"
]
},
"quote": {
"name": "エンタープライズ — 空港、鉄道ネットワーク、国際チェーン",
"f": [
"無制限のボリューム",
"専用デプロイメント",
"SLA & サポート",
"カスタム請求"
]
},
"priceFree": "無料",
"quoteLabel": "カスタム見積もり",
"perMonth": "/mo",
"secTpl": "追加の施設: {p}/mo (-20%)"
},
"ko": {
"free": {
"name": "프리미엄",
"f": [
"1개 시설",
"최대 20개 항목/월",
"통계 없음",
"자동 청구 없음",
"전 세계 이용 가능"
]
},
"small": {
"name": "스타터 — 호텔, 체육관, 레스토랑",
"f": [
"1개 시설 포함 + 무제한 보조 사이트",
"무제한 항목",
"기본 통계",
"자동 청구"
]
},
"medium": {
"name": "비즈니스 — 쇼핑몰, 박물관, 대학",
"f": [
"최대 3개 시설 포함",
"무제한 항목",
"고급 통계",
"회원 초대 · 통합 청구"
]
},
"quote": {
"name": "엔터프라이즈 — 공항, 철도 네트워크, 국제 체인",
"f": [
"무제한 볼륨",
"전담 배포",
"SLA 및 지원",
"맞춤 청구"
]
},
"priceFree": "무료",
"quoteLabel": "맞춤 견적",
"perMonth": "/월",
"secTpl": "추가 시설: {p}/월 (-20%)"
},
"tr": {
"free": {
"name": "Freemium",
"f": [
"1 işletme",
"Aylık maksimum 20 ürün",
"İstatistik yok",
"Otomatik faturalama yok",
"Dünya genelinde kullanılabilir"
]
},
"small": {
"name": "Başlangıç — Oteller, spor salonları, restoranlar",
"f": [
"1 işletme dahil + sınırsız ikincil alan",
"Sınırsız ürün",
"Temel istatistikler",
"Otomatik faturalama"
]
},
"medium": {
"name": "İş — Alışveriş merkezleri, müzeler, üniversiteler",
"f": [
"En fazla 3 işletme dahil",
"Sınırsız ürün",
"İleri düzey istatistikler",
"Üye davetleri · Konsolide faturalama"
]
},
"quote": {
"name": "Kurumsal — Havalimanları, demiryolu ağları, uluslararası zincirler",
"f": [
"Sınırsız hacim",
"Özel dağıtım",
"SLA & destek",
"Özel faturalama"
]
},
"priceFree": "Ücretsiz",
"quoteLabel": "Özel teklif",
"perMonth": "/ay",
"secTpl": "Ek işletme: {p}/ay (-20%)"
}
};
